import { BaseService } from '@partful/shared/api/baseService';

export class CadService extends BaseService {
  async getPresignedUrl(account: string, product: string): Promise<string> {
    const res = await this.client.get<{ url: string }>(`/instructions/cad/${product}`, { params: { account } });
    return res.data.url;
  }
}
